__turbopack_context__.v({
  "container": "s3fjxq_container",
  "inner": "s3fjxq_inner",
});
